export default __webpack_public_path__ + "static/media/a041-2.c7d9f63d.png";